import { render, staticRenderFns } from "./CalendarHeader.vue?vue&type=template&id=42a1aae6&"
import script from "./CalendarHeader.vue?vue&type=script&lang=ts&"
export * from "./CalendarHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports